import React from 'react';
import { ConfirmEmail as InnerField } from '@common/components/Account/components/ConfirmEmail';
import { useAccountRules } from '@common/components/AccountMultiStep/rules/useAccountRules';
import { useTranslation } from '@common/hooks/useTranslation';
import { FieldWrapper } from '../FieldWrapper';

export const ConfirmEmail = () => {
  const { t } = useTranslation();
  const { confirmEmailRules } = useAccountRules();

  return (
    <FieldWrapper<string>
      name="confirmEmail"
      rules={confirmEmailRules}
      render={(props) => {
        const mergedProps = { ...props, t };
        return <InnerField {...mergedProps} />;
      }}
    />
  );
};
